import { Button, Dropdown } from "antd";
import { BaseButtonProps } from "antd/es/button/button";
import { BlogStatusTypes, BlogVisibilityTypes } from "dtos/blog.dto";
import { TbChevronDown, TbStar, TbStarFilled } from "react-icons/tb";
import { toTitleCase } from "utils/functions";

const BlogStatusColors: Record<BlogStatusTypes, BaseButtonProps["color"]> = {
  [BlogStatusTypes.DRAFT]: "geekblue",
  [BlogStatusTypes.PUBLISHED]: "green",
  [BlogStatusTypes.ARCHIVED]: "default",
};

export function BlogStatus({
  value,
  onChange,
}: {
  value?: BlogStatusTypes;
  onChange?: (val: BlogStatusTypes) => void;
}) {
  return (
    <Dropdown
      menu={{
        items: Object.values(BlogStatusTypes).map((val) => ({
          key: val,
          label: toTitleCase(val, { sep: "_", forceLower: true }),
          onClick: () => {
            onChange?.(val);
          },
        })),
      }}
    >
      <Button
        variant="solid"
        color={BlogStatusColors[value ?? BlogStatusTypes.DRAFT]}
        icon={<TbChevronDown />}
        iconPosition="end"
      >
        {toTitleCase(value, { sep: "_", forceLower: true })}
      </Button>
    </Dropdown>
  );
}

const BlogVisibilityColors: Record<BlogVisibilityTypes, BaseButtonProps["color"]> = {
  [BlogVisibilityTypes.HIDDEN]: "red",
  [BlogVisibilityTypes.OPEN_TO_ALL]: "green",
  [BlogVisibilityTypes.MEMBERSHIP_ONLY]: "purple",
  [BlogVisibilityTypes.UNPUBLISHED]: "default",
};

export function BlogVisibility({
  value,
  onChange,
}: {
  value?: BlogVisibilityTypes;
  onChange?: (val: BlogVisibilityTypes) => void;
}) {
  return (
    <Dropdown
      menu={{
        items: Object.values(BlogVisibilityTypes).map((val) => ({
          key: val,
          label: toTitleCase(val, { sep: "_", forceLower: true }),
          onClick: () => {
            onChange?.(val);
          },
        })),
      }}
    >
      <Button
        variant="filled"
        color={BlogVisibilityColors[value ?? BlogVisibilityTypes.OPEN_TO_ALL]}
        icon={<TbChevronDown />}
        iconPosition="end"
      >
        {toTitleCase(value, { sep: "_", forceLower: true })}
      </Button>
    </Dropdown>
  );
}

export function BlogFeatured({ value, onChange }: { value?: boolean; onChange?: (val: boolean) => void }) {
  return (
    <Button
      shape="circle"
      variant={value === true ? "solid" : "filled"}
      color={value === true ? "yellow" : "default"}
      className="ml-auto"
      icon={value === true ? <TbStarFilled /> : <TbStar />}
      onClick={() => {
        onChange?.(!value);
      }}
    />
  );
}
